module.exports = __webpack_public_path__ + "static/media/sl.0ab96fdf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sl.svg
// module id = 1157
// module chunks = 0